import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-aside-tools-inner",
  style: {"position":"fixed","top":"0","left":"0","width":"100vw","height":"100vh","z-index":"9999"}
}
const _hoisted_2 = {
  class: "card",
  style: {"position":"fixed","top":"0","right":"0","width":"30vw","height":"100vh","overflow":"auto","z-index":"10000"}
}
const _hoisted_3 = {
  class: "card-header bg-white d-flex justify-content-between align-items-center",
  style: {"height":"50px"}
}
const _hoisted_4 = { class: "card-title mb-0" }
const _hoisted_5 = { class: "text-primary cursor-pointer" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    opacity: "0.5",
    x: "6",
    y: "17.3137",
    width: "16",
    height: "2",
    rx: "1",
    transform: "rotate(-45 6 17.3137)",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "7.41422",
    y: "6",
    width: "16",
    height: "2",
    rx: "1",
    transform: "rotate(45 7.41422 6)",
    fill: "currentColor"
  })
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = {
  class: "row flex-start mb-3 justify-content-between flex-nowrap",
  style: {"gap":"10px"}
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_MessageTab = _resolveComponent("MessageTab")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_btn, {
      class: "btn btn-warning",
      icon: "sms",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleChatForm()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_tooltip, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("order.tooltip.messageCom")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.showComSidePanel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("Messages et alertes")), 1)
              ]),
              _createElementVNode("span", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeSidePanel && _ctx.closeSidePanel(...args))),
                class: "cursor-pointer"
              }, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_q_btn, {
                  label: _ctx.$t('demand.tabs.message'),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = 'MESSAGE')),
                  class: _normalizeClass(["btn btn-sm w-100", _ctx.activeTab === 'MESSAGE' ? 'btn-primary' : 'btn-outline-primary'])
                }, null, 8, ["label", "class"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  (_ctx.activeTab === 'MESSAGE')
                    ? (_openBlock(), _createBlock(_component_MessageTab, {
                        key: 0,
                        subjects: _ctx.subjectsList,
                        references: _ctx.optionsReference,
                        reference: _ctx.selectedReference,
                        recipients: _ctx.recipientsList,
                        onMessageSent: _ctx.onMessageSent
                      }, null, 8, ["subjects", "references", "reference", "recipients", "onMessageSent"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}